import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { Settings } from "@common/core/config/settings.service";
import { AppHttpClient } from "@common/core/http/app-http-client.service";
import { GenericBackendResponse } from "@common/core/types/backend-response";
import { BehaviorSubject } from "rxjs";
import { HomepageContent } from "../landing/homepage-content";

interface HomepageStats {
  links: number;
  clicks: number;
  users: number;
}
@Component({
  selector: "url-button",
  templateUrl: "./url-button.component.html",
  styleUrls: ["./url-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UrlButtonComponent implements OnInit {
  content: HomepageContent;
  overlayBackground: SafeStyle;
  stats$ = new BehaviorSubject<HomepageStats>(null);

  constructor(
    public settings: Settings,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
    private http: AppHttpClient
  ) {}

  ngOnInit(): void {
    this.settings.all$().subscribe(() => {
      this.content = this.settings.getJson("homepage.appearance");
      this.overlayBackground = this.sanitizer.bypassSecurityTrustStyle(
        `linear-gradient(45deg, ${this.content.headerOverlayColor1} 0%, ${this.content.headerOverlayColor2} 100%)`
      );
      this.cd.markForCheck();
    });
    this.http
      .get<GenericBackendResponse<{ stats: HomepageStats }>>("homepage/stats")
      .subscribe((response) => {
        this.stats$.next(response.stats);
      });
  }
}
